
import "select2";
import * as s2 from "select2";
import "select2/dist/js/i18n/en";

export module Select2Module {

	export async function initAllAsync(container: JQuery): Promise<void> {

		$.fn.select2.defaults.set('amdBase', 'select2/');
		$.fn.select2.defaults.set('amdLanguageBase', 'select2/i18n/');

		var count = container.find("select").not("select.select2-manual").length;

		return new Promise<void>((resolve, reject) => {

			if (count == 0) {
				resolve();
				return;
			}

			$.each(container.find("select").not("select.select2-manual"), async (i, e) => {
				var select2 = new Select2Class($(e));
				await select2.initAsync();
				count -= 1;
				if (count == 0)
					resolve();
			});

		});

	}


	export class Select2Class {

		private element: JQuery;


		constructor(element: JQuery) {
			this.element = element;
		}

		public initAsync(): Promise<void> {
			var options: s2.Options;
			var isMultiple = this.element.attr("multiple") != undefined;

			options = {
				theme: "bootstrap",
				closeOnSelect: !isMultiple
			};

			if (this.element.closest(".modal").length) {
				var parent = this.element.closest(".modal").eq(0)
				options.dropdownParent = parent;
			}

			var self = this;



			return new Promise<void>((resolve, reject) => {

				var _self = self;

				var x = this.element.select2(options);
				(<any>x).on("select2:unselect", (e) => {
					var obj = <any>(_self.element.data("select2"));

					_self.element.data("unselect", true);
					window.setTimeout(() => {
						if (!obj.isOpen())
							obj.open();

						_self.element.data("unselect", false);
					}, 1);

				});
				x.on("select2:select", (e) => {
					if (isMultiple)
						_self.element.siblings(".select2-container--bootstrap").find("input.select2-search__field").val("").focus();
				});


				if (this.element.parents(".input-group").length)
					this.element.siblings(".select2-container--bootstrap").addClass("select2-input-group");

				resolve();
			});

		}

	}

}
